export * from './modules';
export * from './pipes/shared-pipes.module';
export * from './modules';
export * from './guard';


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/index.ts